module.exports = __webpack_public_path__ + "img/edit-icon.284a70c6.svg";